import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { Router } from '@angular/router';
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { AuthService } from '../../services/auth.service';
import { LanguageService } from "../../services/language.service";
import { FormBuilder, FormGroup } from "@angular/forms";
/**
 * Wallet invitation Modal Component
 */
let UpdateUserDataModalComponent = class UpdateUserDataModalComponent {
    constructor(httpClient, sanitizer, router, location, themeService, webSettingsService, auth, languageService, formBuilder) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.auth = auth;
        this.languageService = languageService;
        this.formBuilder = formBuilder;
        this.secondColor = '';
        this.errorColor = '';
        this.linkColor = '';
        this.accentColor = '';
        this.inputBackColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.successColor = '';
        this.backColor = '';
        this.inputTextColor = '';
        this.textColor = '';
        this.logo = '';
        this.mainColor = '';
        this.allEmploymentTypes = [];
        this.allEmploymentTypesByLang = [];
        this.professions = [];
        this.professionsByLang = [];
        this.placeholderText = '';
        this.placeholderTextProfessions = '';
        this.employmentTypeError = false;
        this.professionError = false;
        this.eataError = false;
        this.otherProfessionError = false;
        this.residentError = false;
        this.keywordname = 'name';
        this.dataForUpdate = {};
        this.dropdownEmploymentTypeInFocus = false;
        this.dropdownProfessionInFocus = false;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.eatas = [];
        this.poaos = [];
        this.poaosByLang = [];
        this.placeholderTextPoaos = '';
        this.placeholderTextEatas = '';
        this.dropdownEataInFocus = false;
        this.dropdownPoaoInFocus = false;
        this.otherEataError = false;
        this.poaoError = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.logo = this.themeService.getStyleAttribute('logo_image');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            if (this.logo === '' || this.logo === ' ' || this.logo === null) {
                this.logo = 'assets/img/logo-not-found.png';
            }
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            var _a, _b, _c;
            console.log(lang);
            this.lang = lang ? lang : 'en';
            this.allEmploymentTypesByLang = this.allEmploymentTypes ? this.allEmploymentTypes.filter(employmentType => employmentType.lang === this.lang) : [];
            this.professionsByLang = this.professions ? this.professions.filter(profession => profession.lang === this.lang) : [];
            this.poaosByLang = this.poaos ? this.poaos.filter(poao => poao.lang === this.lang) : [];
            if (this.dataForUpdate.employmentTypeId) {
                this.employmentTypesForm.get('employmentAutoComplete').patchValue((_a = this.allEmploymentTypesByLang.find(employmentType => employmentType.id === this.dataForUpdate.employmentTypeId)) === null || _a === void 0 ? void 0 : _a.name);
            }
            if (this.dataForUpdate.professionId) {
                this.professionsForm.get('professionsAutoComplete').patchValue((_b = this.professionsByLang.find(profession => profession.id === this.dataForUpdate.professionId)) === null || _b === void 0 ? void 0 : _b.name);
            }
            if (this.dataForUpdate.poaoId) {
                this.poaosForm.get('poaosAutoComplete').patchValue((_c = this.poaosByLang.find(poao => poao.id === this.dataForUpdate.poaoId)) === null || _c === void 0 ? void 0 : _c.name);
            }
        });
        this.employmentTypesForm = this.formBuilder.group({
            employmentAutoComplete: ''
        });
        this.professionsForm = this.formBuilder.group({
            professionsAutoComplete: ''
        });
        this.poaosForm = this.formBuilder.group({
            poaosAutoComplete: ''
        });
        location.onPopState(() => {
            this.closeModal2();
        });
    }
    submitData() {
        if (!this.user.newDataPopulated) {
            this.checkProfession();
            this.checkOtherProfession();
            this.checkEmploymentType();
            this.checkResident();
            this.dataForUpdate.isPoaoAndEatas = false;
            if (!this.otherProfessionError &&
                !this.residentError &&
                !this.professionError &&
                !this.employmentTypeError) {
                this.httpClient.post('user/updateuserdata', this.dataForUpdate)
                    .subscribe((result) => {
                    this.auth.fetchUser();
                    this.closeModal2();
                }, (error) => {
                });
            }
        }
        if (!this.user.eataandpoaosPopulated) {
            this.checkPoao();
            this.dataForUpdate.isPoaoAndEatas = true;
            if (!this.poaoError) {
                this.httpClient.post('user/updateuserdata', this.dataForUpdate)
                    .subscribe((result) => {
                    this.auth.fetchUser();
                    this.closeModal2();
                }, (error) => { });
            }
        }
    }
    dontShowMessage() {
        var isPoaoAndEatas = !this.user.eataandpoaosPopulated ? true : false;
        this.httpClient.post('user/dontshowupdateuserdatamessage', {
            "isPoaoAndEatas": isPoaoAndEatas
        })
            .subscribe((result) => {
        }, (error) => {
        });
    }
    ngOnInit() {
        if (!this.user.newDataPopulated) {
            this.getEmploymentTypes();
            this.getProfessions();
        }
        if (!this.user.eataandpoaosPopulated) {
            this.getPoaos();
        }
    }
    onResidentSelectionChange(entry) {
        this.dataForUpdate.resident = entry;
        this.residentError = false;
    }
    checkResident() {
        console.log(this.dataForUpdate.resident);
        if (this.dataForUpdate.resident === undefined || this.dataForUpdate.resident == null) {
            this.residentError = true;
            console.log(1);
        }
    }
    setProfession(item) {
        this.dataForUpdate.professionId = item.id;
        this.checkProfession();
        if (item.id != -1) {
            this.dataForUpdate.otherProfession = '';
        }
    }
    otherProfessionkeyup(value) {
        this.checkOtherProfession();
    }
    checkOtherProfession() {
        if (this.dataForUpdate.professionId === -1) {
            if (this.dataForUpdate.otherProfession === 'null' || this.dataForUpdate.otherProfession === '') {
                this.otherProfessionError = true;
                return;
            }
            else {
                this.otherProfessionError = false;
            }
        }
        else {
            this.otherProfessionError = false;
        }
    }
    onChangeSearchProfession(val) {
    }
    onProfessionClear(e) {
        this.dataForUpdate.professionId = "null";
    }
    onFocusedProfession(e) {
        this.dropdownProfessionInFocus = e;
    }
    checkProfession() {
        if (this.dataForUpdate.professionId == "null" || this.dataForUpdate.professionId === undefined) {
            this.professionError = true;
        }
        else {
            this.professionError = false;
        }
    }
    getProfessions() {
        this.httpClient.get('user/professions').subscribe((data) => {
            this.professions = data;
            this.professionsByLang = this.professions ? this.professions.filter(profession => profession.lang === this.lang) : [];
        });
    }
    getEmploymentTypes() {
        this.httpClient.get('user/employmenttypes').subscribe((data) => {
            this.allEmploymentTypes = data;
            this.allEmploymentTypesByLang = this.allEmploymentTypes ? this.allEmploymentTypes.filter(employmentType => employmentType.lang === this.lang) : [];
        });
    }
    setEmploymentType(item) {
        this.dataForUpdate.employmentTypeId = item.id;
        this.checkEmploymentType();
    }
    checkEmploymentType() {
        if (this.dataForUpdate.employmentTypeId == "null" || this.dataForUpdate.employmentTypeId === undefined) {
            this.employmentTypeError = true;
        }
        else {
            this.employmentTypeError = false;
        }
    }
    onChangeSearchEmploymentType(val) {
    }
    onEmploymentTypeClear(e) {
        this.dataForUpdate.employmentTypeId = "null";
    }
    onFocusedEmploymentType(e) {
        this.dropdownEmploymentTypeInFocus = e;
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
        if (this.data.context == 'login') {
            this.dontShowMessage();
        }
        else if (this.data.context == 'exchange') {
            this.router.navigateByUrl('');
        }
    }
    closeModal2() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
    getEatas() {
        var language = localStorage.getItem('language');
        if (language == null) {
            language = this.lang;
        }
        this.httpClient.get('user/eatas/' + language).subscribe((data) => {
            this.eatas = data;
        }, (error) => {
        });
    }
    setEata(item) {
        this.dataForUpdate.eataId = item.id;
        this.checkEata();
    }
    checkEata() {
        if (this.dataForUpdate.eataId == "null" || this.dataForUpdate.eataId === undefined) {
            this.eataError = true;
        }
        else {
            this.eataError = false;
        }
    }
    onChangeSearcEata(val) {
    }
    onEataClear(e) {
        this.dataForUpdate.eataId = "null";
    }
    onFocusedEata(e) {
        this.dropdownEataInFocus = e;
    }
    otherEatakeyup(value) {
        if (this.dataForUpdate.otherEata === 'null' || this.dataForUpdate.otherEata === undefined || this.dataForUpdate.otherEata === '') {
            this.otherEataError = true;
        }
        else {
            this.otherEataError = false;
        }
    }
    getPoaos() {
        this.httpClient.get('user/poaos').subscribe((data) => {
            this.poaos = data;
            this.poaosByLang = this.poaos ? this.poaos.filter(poao => poao.lang === this.lang) : [];
        });
    }
    setPoao(item) {
        this.dataForUpdate.poaoId = item.id;
        this.checkPoao();
    }
    checkPoao() {
        if (this.dataForUpdate.poaoId == "null" || this.dataForUpdate.poaoId === undefined) {
            this.poaoError = true;
        }
        else {
            this.poaoError = false;
        }
    }
    onChangeSearchPoao(val) {
    }
    onPoaoClear(e) {
        this.dataForUpdate.poaoId = "null";
    }
    onFocusedPoao(e) {
        this.dropdownPoaoInFocus = e;
    }
    checkOtherEata() {
        if (this.dataForUpdate.eataId === '-1' || this.dataForUpdate.eataId == '-1') {
            if (this.dataForUpdate.otherEata === 'null' || this.dataForUpdate.otherEata === undefined || this.dataForUpdate.otherEata === '') {
                this.otherEataError = true;
            }
            else {
                this.otherEataError = false;
            }
        }
    }
};
UpdateUserDataModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: AuthService },
    { type: LanguageService },
    { type: FormBuilder }
];
UpdateUserDataModalComponent = __decorate([
    Component({
        selector: 'update-user-data-modal.component',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./update-user-data-modal.component.html")).default
    })
], UpdateUserDataModalComponent);
export { UpdateUserDataModalComponent };
